import { pipe, trim, split, slice, map, head, join, toUpper } from 'ramda';
export const formatNameToFirstLetters = (name) => {
    if (!name)
        return '';
    return pipe(trim, split(' '), slice(0, 2), map((str) => head(str)), join(''), toUpper)(name);
};
